
  import Vue from 'vue';
  import PopularCategoryCard from '@/components/PopularCategoryCard';
export default {
  components: {
    PopularCategoryCard
  },
  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: this.title,
        },
        {
          hid: 'twitter:title',
          property: 'twitter:title',
          content: this.title,
        },
        {
  hid: 'description',
  name: 'description',
  content: 'Join the St. Francis Xavier Exposition in Goa, a grand celebration of faith and culture featuring historical displays, cultural programs, and spiritual ceremonies honoring the life of St. Francis Xavier.',
},
{
  hid: 'og:description',
  property: 'og:description',
  content: 'Experience the St. Francis Xavier Exposition, where you can explore the rich heritage of Goa through vibrant celebrations, religious rituals, and the display of sacred relics.',
},
{
  hid: 'twitter:description',
  property: 'twitter:description',
  content: 'Immerse yourself in the St. Francis Xavier Exposition, a remarkable event showcasing devotion, culture, and community spirit in honor of the beloved saint.',
},

        {
          hid: 'keywords',
          name: 'keywords',
          content: 'st francis xavier goa, st francis xavier body, st francis xavier goa story, st francis xavier goa feast, st francis xavier exposition years, relics of st francis xavier, st francis xavier goa history, st francis xavier goa church, st francis xavier exposition in goa, st francis xavier exposition goa 2024',
        },
      ],
    };
  },

  components: {},
  data() {
    return {

      reasons: [
    {
      title: "Historical Significance",
      text: "Discover the rich history of St. Francis Xavier and his impact on Christianity in Goa during the exposition.",
    },
    {
      title: "Cultural Celebrations",
      text: "Experience vibrant cultural programs, processions, and traditional music that bring the spirit of Goa to life!",
    },
    {
      title: "Spiritual Journey",
      text: "Participate in heartfelt masses and ceremonies that offer a deep spiritual connection to St. Francis Xavier.",
    },
    {
      title: "Community and Devotion",
      text: "Join thousands of devotees from around the world as they gather to pay respects and celebrate together during this grand event.",
    },
  ],

      title: 'St Francis Xavier Goa - St Francis Xavier Exposition in Goa',
    };
  },

  jsonld() {
  return {
    '@context': 'https://schema.org',
    '@graph': [
    {
                "@type": "ImageObject",
                "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-09-10T09%3A38%3A28.317Zwww.goa.app-%283%29.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=i5F3J1icRaGG4FMl5yKC3W6kOH2B%2B4gpWD1hlsSFBbsLSoz%2FPVUKRCdq5OscjJSfKkQBWTjA%2FWV%2BJw5c2aBzqDdivfWXhcJQaBGYDxYYOfpOcM2X1RZfFDyrxge9DJfrnJZSMGSSU4iwW7MihDz9%2BmwedDHoxCGW%2FapjcPA4glncbAiWKArU0U1E%2FwWDBG6%2BY%2BXS%2FIBtEW0uHNE4J6eHk9h0kgECKpLdT1adCseGSpHG5QdbfV8O0hY1IfqMyFhZoOlczyl2k5%2FTd2hmlARV5jExItMTRoFTFjmSRIp9u2n9dWeklW4L0mXuEUSYmz9ptvklzjEVCcunRzkVJpgCJQ%3D%3D',
                "url": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-09-10T09%3A38%3A28.317Zwww.goa.app-%283%29.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=i5F3J1icRaGG4FMl5yKC3W6kOH2B%2B4gpWD1hlsSFBbsLSoz%2FPVUKRCdq5OscjJSfKkQBWTjA%2FWV%2BJw5c2aBzqDdivfWXhcJQaBGYDxYYOfpOcM2X1RZfFDyrxge9DJfrnJZSMGSSU4iwW7MihDz9%2BmwedDHoxCGW%2FapjcPA4glncbAiWKArU0U1E%2FwWDBG6%2BY%2BXS%2FIBtEW0uHNE4J6eHk9h0kgECKpLdT1adCseGSpHG5QdbfV8O0hY1IfqMyFhZoOlczyl2k5%2FTd2hmlARV5jExItMTRoFTFjmSRIp9u2n9dWeklW4L0mXuEUSYmz9ptvklzjEVCcunRzkVJpgCJQ%3D%3D',
                "contentUrl": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-09-10T09%3A38%3A28.317Zwww.goa.app-%283%29.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=i5F3J1icRaGG4FMl5yKC3W6kOH2B%2B4gpWD1hlsSFBbsLSoz%2FPVUKRCdq5OscjJSfKkQBWTjA%2FWV%2BJw5c2aBzqDdivfWXhcJQaBGYDxYYOfpOcM2X1RZfFDyrxge9DJfrnJZSMGSSU4iwW7MihDz9%2BmwedDHoxCGW%2FapjcPA4glncbAiWKArU0U1E%2FwWDBG6%2BY%2BXS%2FIBtEW0uHNE4J6eHk9h0kgECKpLdT1adCseGSpHG5QdbfV8O0hY1IfqMyFhZoOlczyl2k5%2FTd2hmlARV5jExItMTRoFTFjmSRIp9u2n9dWeklW4L0mXuEUSYmz9ptvklzjEVCcunRzkVJpgCJQ%3D%3D',
                "caption": 'Goa App',
                "inLanguage": "en-US",
                "width": 800,
                "height": 440
            }, 
            {
            "@type": "BlogPosting",
            "@id": `https://www.goa.app/st-francis-xavier-goa`,
                mainEntityOfPage: {
                    '@type': 'WebPage',
                    '@id': `https://www.goa.app/st-francis-xavier-goa`
                },
                "headline": 'Goa App',
                "name": 'Goa App',
                description: '',
                datePublished: '2024-10-26T20:14:36+00:00',
                dateModified: '2024-10-26T20:14:36+00:00',
                author: {
                    '@type': 'Person',
                    name: 'Goa App',
                    url: "https://goa.app"
                },
                publisher: {
                    '@type': 'Organization',
                    "@id": "https://goa.app",
                    name: 'Goa App',
                    logo: {
                        '@type': 'ImageObject',
                        url: 'https://goa.app/goa-app-logo.svg'
                    }
                },
                "image": {
                    "@type": "ImageObject",
                    "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-09-10T09%3A38%3A28.317Zwww.goa.app-%283%29.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=i5F3J1icRaGG4FMl5yKC3W6kOH2B%2B4gpWD1hlsSFBbsLSoz%2FPVUKRCdq5OscjJSfKkQBWTjA%2FWV%2BJw5c2aBzqDdivfWXhcJQaBGYDxYYOfpOcM2X1RZfFDyrxge9DJfrnJZSMGSSU4iwW7MihDz9%2BmwedDHoxCGW%2FapjcPA4glncbAiWKArU0U1E%2FwWDBG6%2BY%2BXS%2FIBtEW0uHNE4J6eHk9h0kgECKpLdT1adCseGSpHG5QdbfV8O0hY1IfqMyFhZoOlczyl2k5%2FTd2hmlARV5jExItMTRoFTFjmSRIp9u2n9dWeklW4L0mXuEUSYmz9ptvklzjEVCcunRzkVJpgCJQ%3D%3D',
                    "url": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-09-10T09%3A38%3A28.317Zwww.goa.app-%283%29.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=i5F3J1icRaGG4FMl5yKC3W6kOH2B%2B4gpWD1hlsSFBbsLSoz%2FPVUKRCdq5OscjJSfKkQBWTjA%2FWV%2BJw5c2aBzqDdivfWXhcJQaBGYDxYYOfpOcM2X1RZfFDyrxge9DJfrnJZSMGSSU4iwW7MihDz9%2BmwedDHoxCGW%2FapjcPA4glncbAiWKArU0U1E%2FwWDBG6%2BY%2BXS%2FIBtEW0uHNE4J6eHk9h0kgECKpLdT1adCseGSpHG5QdbfV8O0hY1IfqMyFhZoOlczyl2k5%2FTd2hmlARV5jExItMTRoFTFjmSRIp9u2n9dWeklW4L0mXuEUSYmz9ptvklzjEVCcunRzkVJpgCJQ%3D%3D',
                    "height": "440",
                    "width": "800"
                },
                "url": `https://www.goa.app/st-francis-xavier-goa`,
                "isPartOf": {
                    "@type": "Blog",
                    "@id": "https://www.goa.app/",
                    "name": "Goa App Blog",
                    "publisher": {
                        "@type": "Organization",
                        "@id": "https://goa.app",
                        "name": "Goa App"
                    }
                },
            },
            {
        "@type": "Event",
        "@id": "https://www.goa.app/st-francis-xavier-goa",
        "name": "St. Francis Xavier Goa",
        "description": "St. Francis Xavier Church in Goa, part of the Basilica of Bom Jesus, houses the sacred relics of the saint, drawing pilgrims from around the world. Every ten years, the grand Exposition is held, featuring cultural programs and spiritual ceremonies honoring his life.",
        "startDate": "2024-11-21",
        "endDate": "2025-01-05",
        "eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode",
        "eventStatus": "https://schema.org/EventScheduled",
        "location": {
          "@type": "Place",
          "name": "Basilica of Bom Jesus",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Old Goa Rd, Bainguinim, Goa",
            "addressLocality": "Goa",
            "postalCode": "403402",
            "addressCountry": "IN"
          }
        },
        "organizer": {
          "@type": "Organization",
          "@id": "https://goa.app",
          "name": "Goa App",
          "url": "https://goa.app"
        },
        "image": {
          "@type": "ImageObject",
          "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-09-10T09%3A38%3A28.317Zwww.goa.app-%283%29.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=i5F3J1icRaGG4FMl5yKC3W6kOH2B%2B4gpWD1hlsSFBbsLSoz%2FPVUKRCdq5OscjJSfKkQBWTjA%2FWV%2BJw5c2aBzqDdivfWXhcJQaBGYDxYYOfpOcM2X1RZfFDyrxge9DJfrnJZSMGSSU4iwW7MihDz9%2BmwedDHoxCGW%2FapjcPA4glncbAiWKArU0U1E%2FwWDBG6%2BY%2BXS%2FIBtEW0uHNE4J6eHk9h0kgECKpLdT1adCseGSpHG5QdbfV8O0hY1IfqMyFhZoOlczyl2k5%2FTd2hmlARV5jExItMTRoFTFjmSRIp9u2n9dWeklW4L0mXuEUSYmz9ptvklzjEVCcunRzkVJpgCJQ%3D%3D',
          "url": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-09-10T09%3A38%3A28.317Zwww.goa.app-%283%29.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=i5F3J1icRaGG4FMl5yKC3W6kOH2B%2B4gpWD1hlsSFBbsLSoz%2FPVUKRCdq5OscjJSfKkQBWTjA%2FWV%2BJw5c2aBzqDdivfWXhcJQaBGYDxYYOfpOcM2X1RZfFDyrxge9DJfrnJZSMGSSU4iwW7MihDz9%2BmwedDHoxCGW%2FapjcPA4glncbAiWKArU0U1E%2FwWDBG6%2BY%2BXS%2FIBtEW0uHNE4J6eHk9h0kgECKpLdT1adCseGSpHG5QdbfV8O0hY1IfqMyFhZoOlczyl2k5%2FTd2hmlARV5jExItMTRoFTFjmSRIp9u2n9dWeklW4L0mXuEUSYmz9ptvklzjEVCcunRzkVJpgCJQ%3D%3D'
        }
      },
            {
        "@type": "WebPage",
        "@id": "https://www.goa.app/st-francis-xavier-goa",
        "url": "https://www.goa.app/st-francis-xavier-goa",
        "name": "St Francis Xavier Exposition",
        "isPartOf": {
            "@id": "https://www.goa.app/#website"
        },
        "primaryImageOfPage": {
            "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-09-10T09%3A38%3A28.317Zwww.goa.app-%283%29.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=i5F3J1icRaGG4FMl5yKC3W6kOH2B%2B4gpWD1hlsSFBbsLSoz%2FPVUKRCdq5OscjJSfKkQBWTjA%2FWV%2BJw5c2aBzqDdivfWXhcJQaBGYDxYYOfpOcM2X1RZfFDyrxge9DJfrnJZSMGSSU4iwW7MihDz9%2BmwedDHoxCGW%2FapjcPA4glncbAiWKArU0U1E%2FwWDBG6%2BY%2BXS%2FIBtEW0uHNE4J6eHk9h0kgECKpLdT1adCseGSpHG5QdbfV8O0hY1IfqMyFhZoOlczyl2k5%2FTd2hmlARV5jExItMTRoFTFjmSRIp9u2n9dWeklW4L0mXuEUSYmz9ptvklzjEVCcunRzkVJpgCJQ%3D%3D'
        },
        "image": {
            "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-09-10T09%3A38%3A28.317Zwww.goa.app-%283%29.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=i5F3J1icRaGG4FMl5yKC3W6kOH2B%2B4gpWD1hlsSFBbsLSoz%2FPVUKRCdq5OscjJSfKkQBWTjA%2FWV%2BJw5c2aBzqDdivfWXhcJQaBGYDxYYOfpOcM2X1RZfFDyrxge9DJfrnJZSMGSSU4iwW7MihDz9%2BmwedDHoxCGW%2FapjcPA4glncbAiWKArU0U1E%2FwWDBG6%2BY%2BXS%2FIBtEW0uHNE4J6eHk9h0kgECKpLdT1adCseGSpHG5QdbfV8O0hY1IfqMyFhZoOlczyl2k5%2FTd2hmlARV5jExItMTRoFTFjmSRIp9u2n9dWeklW4L0mXuEUSYmz9ptvklzjEVCcunRzkVJpgCJQ%3D%3D'
        },
        "thumbnailUrl": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2024-09-10T09%3A38%3A28.317Zwww.goa.app-%283%29.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=i5F3J1icRaGG4FMl5yKC3W6kOH2B%2B4gpWD1hlsSFBbsLSoz%2FPVUKRCdq5OscjJSfKkQBWTjA%2FWV%2BJw5c2aBzqDdivfWXhcJQaBGYDxYYOfpOcM2X1RZfFDyrxge9DJfrnJZSMGSSU4iwW7MihDz9%2BmwedDHoxCGW%2FapjcPA4glncbAiWKArU0U1E%2FwWDBG6%2BY%2BXS%2FIBtEW0uHNE4J6eHk9h0kgECKpLdT1adCseGSpHG5QdbfV8O0hY1IfqMyFhZoOlczyl2k5%2FTd2hmlARV5jExItMTRoFTFjmSRIp9u2n9dWeklW4L0mXuEUSYmz9ptvklzjEVCcunRzkVJpgCJQ%3D%3D',
        "datePublished": "2024-10-26T20:14:36+00:00",
        "dateModified": "2024-10-26T20:14:36+00:00",
        "description": "St. Francis Xavier Church in Goa, part of the Basilica of Bom Jesus, houses the sacred relics of the saint, drawing pilgrims from around the world. Every ten years, the grand Exposition is held, featuring cultural programs and spiritual ceremonies honoring his life.",
        "breadcrumb": {
            "@id": "https://www.goa.app/st-francis-xavier-goa/#breadcrumb"
        },
        "inLanguage": "en-US",
        "potentialAction": [{
            "@type": "ReadAction",
            "target": ["https://www.goa.app/st-francis-xavier-goa"]
        }]
      },
      {
        '@type': 'FAQPage',
        'mainEntity': [
          {
           '@type': 'Question',
  'name': 'How do I visit St. Francis Xavier Goa?',
  'acceptedAnswer': {
    '@type': 'Answer',
    'text': 'You can visit St. Francis Xavier Goa by going to the Basilica of Bom Jesus in Old Goa, where his relics are preserved. The church is open to visitors all year round, with special events during the exposition.'
  }
},
{
  '@type': 'Question',
  'name': 'What happens during the St. Francis Xavier Exposition in Goa?',
  'acceptedAnswer': {
    '@type': 'Answer',
    'text': 'During the St. Francis Xavier Exposition, the saint’s relics are displayed for public veneration. The event includes special masses, processions, and cultural programs celebrating his legacy.'
  }
},
{
  '@type': 'Question',
  'name': 'When is the best time to visit St. Francis Xavier Goa?',
  'acceptedAnswer': {
    '@type': 'Answer',
    'text': 'The best time to visit St. Francis Xavier Goa is during the exposition, held every ten years. It attracts visitors worldwide for spiritual and cultural events.'
  }
},
{
  '@type': 'Question',
  'name': 'Is there a fee to enter St. Francis Xavier Church in Goa?',
  'acceptedAnswer': {
    '@type': 'Answer',
    'text': 'No, there is no entry fee to visit St. Francis Xavier Church in Goa, but donations are welcomed to help maintain the church and support religious events like the exposition.'
  }
},
{
  '@type': 'Question',
  'name': 'Can tourists attend the St. Francis Xavier Exposition in Goa?',
  'acceptedAnswer': {
    '@type': 'Answer',
    'text': 'Yes, tourists are welcome to attend the St. Francis Xavier Exposition in Goa. It’s a significant cultural and religious event, offering a glimpse into Goa’s spiritual heritage.'
  }
},
{
  '@type': 'Question',
  'name': 'How long does the St. Francis Xavier Exposition last?',
  'acceptedAnswer': {
    '@type': 'Answer',
    'text': 'The St. Francis Xavier Exposition typically lasts for a month, culminating in the feast day celebrations on 3rd December.'
  }
},
{
  '@type': 'Question',
  'name': 'Are there special masses held at St. Francis Xavier Goa?',
  'acceptedAnswer': {
    '@type': 'Answer',
    'text': 'Yes, special masses are held during the St. Francis Xavier Exposition, where devotees gather to honor the saint’s legacy through prayer and religious services.'
  }
},
{
  '@type': 'Question',
  'name': 'Can I participate in the ceremonies at St. Francis Xavier Goa?',
  'acceptedAnswer': {
    '@type': 'Answer',
    'text': 'Yes, all visitors are welcome to participate in the ceremonies, including masses and processions during the St. Francis Xavier Exposition.'
  }
},
{
  '@type': 'Question',
  'name': 'Is St. Francis Xavier Goa suitable for tourists?',
  'acceptedAnswer': {
    '@type': 'Answer',
    'text': 'Absolutely! St. Francis Xavier Goa is a major tourist destination, especially during the exposition. It’s a cultural and spiritual experience for visitors of all ages.'
  }
},
{
  '@type': 'Question',
  'name': 'Are there any accommodations available near St. Francis Xavier Goa during the exposition?',
  'acceptedAnswer': {
    '@type': 'Answer',
    'text': 'Yes, many accommodations in Old Goa offer special packages during the exposition period, but it’s best to book early due to high demand.'
  }
},
{
  '@type': 'Question',
  'name': 'Is there food available near St. Francis Xavier Goa during the exposition?',
  'acceptedAnswer': {
    '@type': 'Answer',
    'text': 'Yes, food stalls offering local delicacies are usually set up near the Basilica during the exposition, providing refreshments for visitors.'
  }
          }
        ]
      }
    ]
  };
},


};


  